<div class="w-full max-w-5xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px] flex flex-row">
        <button mat-button type="button" (click)="goBack()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
        </button>
        <h2 class="!mt-0 content-center">{{ getTitle() }}</h2>
    </div>

    <span class="separator-line block"></span>

    <div class="mt-8">
        <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="displayedData" class="w-[100%]">
            <ng-container matColumnDef="typeLabel">
                <th mat-sort-header="typeLabel" mat-header-cell *matHeaderCellDef>Tegund</th>
                <td mat-cell *matCellDef="let element">
                    <button type="button" class="c-link" (click)="openEntry(element)">
                        {{ element.typeLabel }}
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="createdByName">
                <th mat-sort-header="createdByName" mat-header-cell *matHeaderCellDef>Skráningaraðili</th>
                <td mat-cell *matCellDef="let element">{{ element.createdByName }}</td>
            </ng-container>

            <ng-container matColumnDef="createdDate">
                <th mat-sort-header="createdDate" mat-header-cell *matHeaderCellDef>Dagsetning</th>
                <td mat-cell *matCellDef="let element">{{ formatDate(element.createdDate) }}</td>
            </ng-container>

            <ng-container matColumnDef="hasAttachments">
                <th mat-header-cell *matHeaderCellDef>Viðhengi</th>
                <td mat-cell *matCellDef="let element">
                    @if (element.hasAttachments) {
                        <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_outline:paper-clip'"></mat-icon>
                    } @else {
                        <span class="text-secondary">-</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-sort-header="status" mat-header-cell *matHeaderCellDef>Staða</th>
                <td mat-cell *matCellDef="let element">
                    <span
                        class="inline-flex items-center font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase"
                        [ngClass]="{
                            'bg-orange-200 text-orange-800 dark:bg-orange-600 dark:text-orange-50':
                                element.status === InterestRegisterEntryStatus.Submitted,
                            'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50':
                                element.status === InterestRegisterEntryStatus.Reviewed,
                        }"
                    >
                        {{ element.status === InterestRegisterEntryStatus.Reviewed ? 'Yfirfarið' : 'Móttekið' }}
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row class="interest-register-row" *matRowDef="let row; columns: displayedColumns" (click)="openEntry(row)"></tr>

            <tr class="mat-row" *matNoDataRow>
                @if (!isLoading) {
                    <td class="p-4 text-secondary" [attr.colspan]="displayedColumns.length">Engar skráningar fundust.</td>
                }
            </tr>
        </table>

        @if (isLoading) {
            <div class="flex justify-center items-center gap-2 pt-4 pb-4 bg-white">
                <mat-progress-spinner [diameter]="16" [mode]="'indeterminate'"></mat-progress-spinner>
                Sæki skráningar
            </div>
        }
    </div>
</div>
